export const changeRatingUrl = url => {
  /* istanbul ignore else */
  if (url && url.length) {
    url = url.split('/');
    url[url.length - 1] = `s${url[url.length - 1]}`;
    url = url.join('/');
  }
  return url;
};
export const addHttpsImagePath = url => {
  return url && (url.includes('https') ? url : url.replace('http', 'https'));
};
export const checkForPropsValue = (
  componentField,
  pageLevelField,
  dictionaryField
) => {
  if (componentField && componentField.value.length) {
    return componentField;
  } else if (pageLevelField && pageLevelField.value.length) {
    return pageLevelField;
  }
  return dictionaryField;
};
